import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getAudienceList } from 'components/audience/AudienceAPI';
import { setAudienceList, setAudienceDashboardAudienceList } from 'store/slice/ManufSlice';
import AudienceDashboard from '../AudienceDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function AudiencePageImpl() {
    const dispatch = useDispatch();
    const { audienceList} = useSelector((state)=>state.manufslice);
    
    const getAudienceListSuccess = (list) =>{dispatch(setAudienceList(list));}
    useEffect(() => {
        getAudienceList(()=>{}, getAudienceListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setAudienceDashboardAudienceList( audienceList));
    },[ audienceList])

    return (
        < AudienceDashboard />
    )

}